const About = () => {
    return (
        <>
            <div className="container p-4 px-5 text-center ">
                <div className="bg-light">
                    <header>
                        <h1>About Us</h1>
                    </header>
                    <main>
                        <section className="about-us">
                            <h2>Welcome to PlayPal</h2>
                            <div className="row d-flex justify-content-center">
                                <div className="col-8 text-start py-4 ">
                                    <span >
                                        <strong>“PlayPal”</strong> , the ultimate platform for connecting sports enthusiasts across different areas. Whether you're looking to find a local sports match or purchase sports items, PlayPal has got you covered. Through our innovative website, you can easily connect with like-minded individuals who share your passion for sports.With PlayPal, you can join group chats, organize sports matches, and form new friendships within the sports community. But PlayPal offers more than just social connections . Through our shopping page, you can conveniently browse and purchase a wide range of sports items to enhance your performance and style on the field . Our goal at PlayPal is to bring people together, break down geographical barriers, and create a vibrant sports community . By utilizing the power of technology, PlayPal bridges the gap between virtual and physical sports communities . Worldwide use of the Internet by business and commerce has recently increased dramatically . Indeed, many commentators now claim that the Internet is leading to a new period in marketing, and PlayPal is at the forefront of this trend in the sports industry. Through PlayPal, sports industry leaders and enthusiasts can harness the potential of social media to connect, engage, and share their love for sports . By providing a platform for communication and interaction, PlayPal allows users to not only connect with others but also contribute to the growth and development of the sports industry as a whole.
                                    </span>



                                </div>
                            </div>

                        </section>
                    </main>
                </div>

            </div>




        </>
    )
}

export default About